<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Câbles :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchCablesList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.CablesHeaders"
                        :items="$store.state.cablesListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchCablesList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            color="primary"
                                            dark
                                            class="mb-1"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            +
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireCables></FormulaireCables>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.cablesEditedItem.REFERENCE != '' && 
                                                    $store.state.cablesEditedItem.DESC_NL != '' && 
                                                    $store.state.cablesEditedItem.DESC_FR != '' &&
                                                    $store.state.cablesEditedItem.TYPE != '' &&
                                                    $store.state.cablesEditedItem.SECTION != '' &&
                                                    $store.state.cablesEditedItem.LENGTH > 0 &&
                                                    $store.state.cablesEditedItem.CONNECTORS != '' " 
                                                color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog
                                    v-model="dialogCopy"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Copier le câble</span>
                                        </v-card-title>
                                        <FormulaireCables></FormulaireCables>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeCopy"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="
                                                    $store.state.cablesEditedItem.REFERENCE != '' && 
                                                    $store.state.cablesEditedItem.DESC_NL != '' && 
                                                    $store.state.cablesEditedItem.DESC_FR != '' &&
                                                    $store.state.cablesEditedItem.TYPE != '' &&
                                                    $store.state.cablesEditedItem.SECTION != '' &&
                                                    $store.state.cablesEditedItem.LENGTH > 0 &&
                                                    $store.state.cablesEditedItem.CONNECTORS != '' " 
                                                color="blue darken-1"
                                                text
                                                @click="saveCopy"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer ce câble ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.cablesEditedItem.Reference }} {{ $store.state.cablesEditedItem.CableAlias }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="copyItem(item)"
                            >
                                mdi-content-copy
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.FullBlack="{ item }">
                            <v-simple-checkbox
                                v-model="item.FullBlack"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.Bisun="{ item }">
                            <v-simple-checkbox
                                v-model="item.Bisun"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.optimizer="{ item }">
                            <v-simple-checkbox
                                v-model="item.optimizer"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
	import FormulaireCables from './FormulaireCables.vue';

	export default {
    name: "GestionCables",
    components: { FormulaireCables },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            formHasErrors: false,
            defaultItem: {
                REFERENCE: '',
                DESC_NL: '',
                DESC_FR: '',
                TYPE: '',
                SECTION: '',
                LENGTH: 0,
                CONNECTORS: '',
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouveau câble" : "Modifier le câble";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogCopy(val) {
            val || this.closeCopy();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createCablesListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        editItem(item) {
            this.editedIndex = this.$store.state.cablesListBool.indexOf(item);
            this.$store.state.cablesEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.cablesListBool.indexOf(item);
            this.$store.state.cablesEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.cablesListBool.indexOf(item);
            this.$store.state.cablesEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.cablesListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteCable.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.cablesEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.cablesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.cablesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadCablesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.cablesList = response.data;
                        this.createCablesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.cablesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.cablesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.cablesEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.cablesListBool[this.editedIndex], this.$store.state.cablesEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editCable.php";
            }
            else {
                this.$store.state.cablesListBool.push(this.$store.state.cablesEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addCable.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.cablesEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.cablesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.cablesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadCablesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.cablesList = response.data;
                        this.createCablesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addCable.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.cablesEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.cablesResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.cablesListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadCablesList.php";
                    axios.get(link).then(response => {
                        this.$store.state.cablesList = response.data;
                        this.createCablesListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
    },
}
</script>
